export default "__VITE_ASSET__LuahhZ6X__"